export function generateUniqueName(prefix = '', existingNames) {
    let name = prefix;
    let suffix = 2;
    while (existingNames.includes(name)) {
        name = `${prefix} ${suffix}`;
        suffix++;
    }
    return name;
}
